// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading___P-X4","icon":"icon__1LcyL","wrapper":"wrapper__3lDTZ","subHeading":"subHeading__-EcWP","block":"block__DV8aU"};